export const WORKSPACE_MAPS_API_ROOT = '/__workspace_maps'
export const WORKSPACE_MAPS_INDEX_PATH = `${WORKSPACE_MAPS_API_ROOT}/list`
export const WORKSPACE_MAPS_LOAD_PATH = `${WORKSPACE_MAPS_API_ROOT}/load`
export const WORKSPACE_MAPS_SAVE_PATH = `${WORKSPACE_MAPS_API_ROOT}/save`
